import script from "./SidebarObstacles.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarObstacles.vue?vue&type=script&setup=true&lang=js"

import "./SidebarObstacles.vue?vue&type=style&index=0&id=6d26601e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d26601e"]])

export default __exports__